export default function NotFound(){

    return (
        <div className="rounded-sm mt-10 m-4 p-3 px-6 w-fit ml-auto mr-auto bg-[#363735] md:ml-4 md:mr-4">
            <div className="text-xl font-bold">404 Not Found</div>
            <div className="text-sm mt-2">
            This page is no longer available. Either the link is invalid,expired or has been removed by the creator.
            </div>
        </div>
    )
}